<template>
  <div>
    <md-card class="card-container">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="isEditing ? '修改地點' : '新增地點'"></page-title>
        </div>
      </div>
      <div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>名稱</label>
              <md-input v-model="data.name"></md-input>
            </md-field>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>地址</label>
              <md-input v-model="data.address"></md-input>
            </md-field>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>執照號碼</label>
              <md-input v-model="data.license_id"></md-input>
            </md-field>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>電話號碼</label>
              <md-input v-model="data.phone_number"></md-input>
            </md-field>
          </div>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised" @click="goLocationList">返回</md-button>
          <md-button class="md-raised md-accent" @click="removeLocation">刪除地點</md-button>
        </div>
        <div class="md-layout-item">
          <md-button class="md-raised md-primary float-right" @click="submit">送出</md-button>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import axios from 'axios'
import urls from '@/urls'

export default {
  data () {
    return {
      isEditing: null,
      data: {
      }
    }
  },
  components: {
    PageTitle
  },
  created: function () {
    if (this.$route.params.id !== 'add') {
      this.isEditing = this.$route.params.id
    }
    if (this.isEditing) {
      this.readLocation(this.isEditing)
    }
  },
  methods: {
    goLocationList () {
      this.$router.push('/location')
    },
    submit: async function () {
      let url
      if (this.isEditing) {
        url = urls({route: 'location', id: this.isEditing})
        await axios.put(url, this.data)
      } else {
        url = urls({route: 'location'})
        await axios.post(url, this.data)
      }
      this.goLocationList()
    },
    removeLocation: async function () {
      await axios.delete(urls({route: 'location', id: this.isEditing}))
      this.goLocationList()
    },
    readLocation: async function (locationID) {
      let req = await axios.get(urls({route: 'location', id: this.isEditing}))
      this.data = req.data.data
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Location/LocationEdit.vue